import type {
	DefaultFeatureFlagValue,
	FeatureFlagValue,
} from '@atlassian/jira-feature-flagging-using-meta';

/**
 * IT ALWAYS RETURNS THE DEFAULT DO NOT USE
 *
 * @param defaultValue No other values allowed other than false go/ff-default
 */
export const ff = (_featureFlagName: string, defaultValue: false = false): boolean => {
	return defaultValue;
};

/**
 * IT ALWAYS RETURNS THE DEFAULT DO NOT USE
 *
 * @deprecated Use `expVal` instead - see https://hello.atlassian.net/wiki/spaces/JFP/pages/3382881038/Jira+Playbook+Statsig for more details.
 *
 * Retrieves the feature flag value for a multivariate flag
 *
 * Multivariate flags are feature flags that allow more than 2 (e.g. boolean) variations.
 * We only support string types as variations, so `T` should be a string.
 * For better type safety, make TypeScript narrow down from `string` to concrete string literals
 * by including `as const` after the array of possible values, like in the example below.
 *
 * @example
 * ```
 * getMultivariateFeatureFlag(
 *     'flag-key',
 *     'control',
 *     ['control', 'experiment-alpha', 'experiment-beta'] as const
 *  );
 * ```
 *
 * @param featureFlagName The feature flag key
 * @param defaultValue The string value we should default to when the feature flag could not be evaluated
 * @param possibleValues All the possible variations as strings
 * @returns The feature flag value as a string
 */
export function getMultivariateFeatureFlag<T extends string>(
	_featureFlagName: string,
	defaultValue: T,
	_possibleValues: Readonly<T[]>,
): T {
	return defaultValue;
}

/**
 * IT ALWAYS RETURNS THE DEFAULT DO NOT USE
 *
 * @deprecated Use `expVal` or `fg` instead - see https://hello.atlassian.net/wiki/spaces/JFP/pages/3382881038/Jira+Playbook+Statsig for more details.
 * @param defaultValue boolean 'true' value is not allowed go/ff-default
 */
export function getFeatureFlagValue<T extends FeatureFlagValue>(
	_featureFlagName: string,
	defaultValue: T extends DefaultFeatureFlagValue ? T : never,
): T {
	return defaultValue;
}
